<section class="container">
  <form id="doc__technics__form" class="form__box">
    <div class="form-row mb-2 mb-xl-5">

      <!-- Category -->
      <div class="form-group config__group col-md-6 col-xl-3 pr-md-4 mb-4 mb-xl-0">
        <label class="contact__form__text mb-1" for="category">
          <p class="little mb-2 color--grey--dark">{{ i18n["techdocs.select-category"] }}</p>
        </label>
        <select name="category" id="category" (change)="onCategoryChange($event)" class="select config__form__control config__form__control--light form-control">
          <option value="">{{ i18n["common.category"] }}</option>
          <option *ngFor="let category of categories" value="{{ category.id }}">{{ category.name }}</option>
        </select>
      </div>

      <!-- Family -->
      <div class="form-group config__group col-md-6 col-xl-3 pr-md-4 mb-4 mb-xl-0">
        <label class="contact__form__text mb-1" for="family">
          <p class="little mb-2 color--grey--dark">
            {{ i18n["techdocs.select-family"] }}
          </p>
        </label>
        <select name="family" id="family" (change)="onFamilyChange($event)" class="select config__form__control config__form__control--light form-control">
          <option value="">{{ i18n["common.family"] }}</option>
          <option *ngFor="let family of families" value="{{ family.id }}">{{ family.name }}</option>
        </select>
      </div>

      <!-- Format -->
      <div class="form-group config__group col-md-6 col-xl-3 pr-md-4 mb-4 mb-xl-0">
        <label class="contact__form__text mb-1" for="format">
          <p class="little mb-2 color--grey--dark">
            {{ i18n["techdocs.select-format"] }}
          </p>
        </label>
        <select name="format" id="format" class="select config__form__control config__form__control--light form-control">
          <option value="">{{ i18n["common.format"] }}</option>
          <option *ngFor="let format of formats" value="{{ format.id }}">{{ format.name }}</option>
        </select>
      </div>

      <!-- Button -->
      <div class="form-group config__group align-items-md-end col-md-12 col-xl-3 pr-md-4 mb-3 mb-lg-0">
        <button [disabled]="isDisabled" id="search_button" type="submit" class="btn button button--little btn-primary btn-primary--grad contact__form__button mt-3">
          {{ i18n["common.search.docs"] }}
        </button>
      </div>

    </div>
  </form>
</section>
